module.exports = __webpack_public_path__ + "img/cca-clogo.510b9b0b.svg";